import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import * as Roles from '../../common/Roles';

const states: Ng1StateDeclaration[] = [
    {
        name: 'applications',
        url: '/applications',
        component: 'wtApplicationsState',
        resolve: {
            auth: Resolve.authResolve,
            license: Resolve.licenseResolve
        },
        abstract: false,
        redirectTo: 'applications.management',
        data: {
            visible: true,
            hideWhenConnected: true,
            sortingOrder: 102,
            icon: 'fa-file-archive-o',
            displayName: 'Applications',
            editRoles: [Roles.administrator, Roles.engineer],
            editButtonVisibility: () => false
        }
    }];

export default states;